/* ---- BAG ADD-ONS ----
   Two suggestions in the bag: a BRIO strap and a Fit Case, both keyed to
   the colour of the frame already in it.

   WHY IT WATCHES THE BAG INSTEAD OF WRAPPING renderBag.
   The first version replaced window.SF.renderBag with a wrapper. It did not
   work, and the reason is worth keeping: inside sf-claude.js the functions
   call each other by their own names, so openBag() runs the INTERNAL
   renderBag, not the one published on window.SF. Reassigning the published
   name only catches calls made from outside — which meant it fired when
   tested by hand from the console and never once when a shopper opened
   their bag. Watching the rendered result is what sf-quickfix and
   sf-minifallback already do here, for the same reason.

   THE TWO ROWS ARE NOT THE SAME PROMISE, AND DO NOT CLAIM TO BE.
   Fit Case is made in eighteen colours, so it can answer any frame exactly.
   BRIO is made in two, Black and Brown, so for most frames there is no
   matching strap at all. Rather than drop the strap or pretend, the strap
   falls back to whichever of its two reads as neutral beside that frame —
   Brown for the warm colours, Black for the rest — and says "goes with
   everything" instead of "matches your frame". Only an exact colour hit is
   ever called a match.

   A ROW DISAPPEARS ONCE ITS ITEM IS IN THE BAG, rather than the whole block
   vanishing on the first accessory added: having taken the strap is not a
   reason to stop offering the case.

   NOTHING IS PITCHED ON FREE DELIVERY. That sits at 25 KD and a 2.500 KD
   case cannot close a gap that a 25 KD frame has already closed.
*/
(function(){
"use strict";
var DATA={}; try{ DATA=JSON.parse((document.getElementById('sf-data')||{}).textContent||"{}") }catch(e){}
var FAMS=DATA.families||[], ADDONS=DATA.addons||[], OFF=DATA.addon_discount||0.10;
if(!ADDONS.length) return;

var money=function(c){return (c/1000).toFixed(3)+" KD"};

/* Frame colour to the BRIO colour that genuinely matches, where one exists. */
var STRAP={black:'Black', brown:'Brown', tortoise:'Brown'};

/* Everything else gets the neutral that sits best beside it. */
var WARM={gold:1, beige:1, nude:1, orange:1, red:1, maroon:1, burgundy:1, yellow:1, tortoise:1};

/* Frame colour to the closest Fit Case. The raw words the theme folds
   (nude, burgundy, maroon, navy) are listed as well, so this still answers
   for a family whose colour_map has not been written in folded names. */
var CASE={black:'Black', brown:'Brown', tortoise:'Brown', grey:'Grey', silver:'Silver',
 gold:'Beige', beige:'Beige', nude:'Beige', clear:'Beige', blue:'Blue', navy:'Navy',
 green:'Green', yellow:'Yellow', orange:'Orange', red:'Red', maroon:'Maroon',
 burgundy:'Maroon', pink:'Baby Pink', tiffany:'Tiffany'};

var BY_VID=null;
function colourByVariant(){
  if(BY_VID) return BY_VID;
  BY_VID={};
  FAMS.forEach(function(f){
    var m={};
    String(f.cmap||'').split(';').forEach(function(pair){
      var i=pair.indexOf('='); if(i<0) return;
      m[pair.slice(0,i).trim()]=pair.slice(i+1).split('|')[0].trim();
    });
    (f.products||[]).forEach(function(p){
      var c=m[String(p.pid)];
      if(c) BY_VID[String(p.id)]=c.toLowerCase();
    });
  });
  return BY_VID;
}
function byTitle(t){
  t=String(t).toLowerCase();
  for(var i=0;i<ADDONS.length;i++) if(String(ADDONS[i].title).toLowerCase()===t) return ADDONS[i];
  return null;
}
/* "BRIO Plain Sunglasses Strap | Brown" does not fit the row and truncates
   to nonsense on a phone. The shelf name is not the name a shopper needs. */
function shortName(t){ return String(t).split('Plain Sunglasses Strap').join('Strap') }
function esc(s){ return String(s).split('&').join('&amp;').split('<').join('&lt;').split('"').join('&quot;') }

function strapFor(c){
  if(STRAP[c]){
    var exact=byTitle('BRIO Plain Sunglasses Strap | '+STRAP[c]);
    if(exact) return {item:exact, match:true};
  }
  var neutral=byTitle('BRIO Plain Sunglasses Strap | '+(WARM[c]?'Brown':'Black'));
  return neutral ? {item:neutral, match:false} : null;
}
function caseFor(c){
  if(!CASE[c]) return null;
  var hit=byTitle('Fit Case | '+CASE[c]);
  return hit ? {item:hit, match:true} : null;
}
function rowHTML(r){
  var a=r.item, net=Math.round(a.price*(1-OFF));
  return '<div class="bagaddon"><img src="'+esc(a.img)+'" alt="">'+
    '<div class="m"><b>'+esc(shortName(a.title))+'</b><span>'+
    (r.match?'Matches your frame':'Goes with everything')+' &middot; 10% off</span></div>'+
    '<span class="mono">'+money(net)+'<s>'+money(a.price)+'</s></span>'+
    '<button type="button" onclick="SF.addAddon('+a.id+')">Add</button></div>';
}
function blockFor(cart){
  var map=colourByVariant(), colour=null, inBag={};
  (cart.items||[]).forEach(function(l){
    var v=String(l.variant_id||l.id);
    inBag[v]=1;
    if(!colour && map[v]) colour=map[v];
  });
  if(!colour) return '';
  var c=String(colour).toLowerCase();

  var s=strapFor(c), k=caseFor(c), rows=[];
  /* The exact match leads; a neutral suggestion follows it. */
  if(s && s.match) rows.push(s);
  if(k) rows.push(k);
  if(s && !s.match) rows.push(s);

  rows=rows.filter(function(r){ return !inBag[String(r.item.id)] });
  if(!rows.length) return '';

  return '<div class="bagaddons"><div class="bal">Make it a set</div>'+
    rows.map(rowHTML).join('')+'</div>';
}

/* The bag is rebuilt from scratch on every change, so the block goes with
   it and has to be put back. Re-entry is stopped by the presence test, not
   by disconnecting the observer: an early return costs nothing and cannot
   leave the observer switched off. */
var working=false;
function fill(){
  var b=document.getElementById('bagBody');
  if(!b || working) return;
  if(!b.querySelector('.meter')) return;       /* mid-render, or empty bag */
  if(b.querySelector('.bagaddons')) return;    /* already placed */
  working=true;
  fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json()})
    .then(function(c){
      working=false;
      if(!c.item_count) return;
      var html=blockFor(c); if(!html) return;
      var b2=document.getElementById('bagBody');
      if(!b2 || b2.querySelector('.bagaddons')) return;
      b2.insertAdjacentHTML('beforeend', html);
    })
    .catch(function(){ working=false });
}

var css='.bagaddons{margin-top:16px}'+
 '.bagaddons .bal{font-size:10px;letter-spacing:.09em;text-transform:uppercase;'+
 'color:var(--mute);margin:0 0 8px}'+
 '[dir="rtl"] .bagaddons .bal{letter-spacing:normal;text-transform:none;font-size:12px}'+
 '.bagaddon{display:flex;align-items:center;gap:10px;padding:10px 11px;'+
 'border:1px solid var(--line);border-radius:10px;background:#fff}'+
 '.bagaddon + .bagaddon{margin-top:8px}'+
 '.bagaddon img{width:42px;height:42px;flex:none;object-fit:cover;border-radius:6px;background:var(--soft)}'+
 '.bagaddon .m{flex:1;min-width:0}'+
 '.bagaddon .m b{display:block;font-size:12.5px;font-weight:400;line-height:1.3;'+
 'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'+
 '.bagaddon .m span{display:block;font-size:11px;color:var(--mute);margin-top:2px}'+
 '.bagaddon .mono{font-size:12px;white-space:nowrap;text-align:right}'+
 '.bagaddon .mono s{display:block;font-size:10px;color:var(--mute)}'+
 '.bagaddon button{flex:none;border:1px solid var(--ink);background:none;border-radius:999px;'+
 'padding:7px 14px;font:inherit;font-size:10.5px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer}'+
 '.bagaddon button:hover{background:var(--ink);color:#fff}'+
 '[dir="rtl"] .bagaddon .mono{text-align:left}';
var st=document.createElement('style'); st.appendChild(document.createTextNode(css));
document.head.appendChild(st);

/* addAddon is a new key on SF, so publishing it is safe — unlike replacing
   one, which the internal calls would ignore. */
function publish(){
  if(!window.SF || typeof window.SF.addVariant!=='function') return false;
  window.SF.addAddon=function(id){ return window.SF.addVariant(id,1,{_set:'yes'}) };
  return true;
}
function watch(){
  var b=document.getElementById('bagBody');
  if(!b) return;
  var queued=false;
  new MutationObserver(function(){
    if(queued) return;
    queued=true;
    requestAnimationFrame(function(){ queued=false; fill() });
  }).observe(b, {childList:true});
  fill();
}
function boot(){
  if(!publish()){
    var n=0, t=setInterval(function(){ if(publish()||++n>60) clearInterval(t) },100);
  }
  watch();
}
if(document.readyState==='complete') boot();
else window.addEventListener('load', boot);
})();
